import ScrollToTop from "@common/ScrollToTop";
import YouMayLike from "@pages/Promotions/Promotion/YouMayLike";
import { respondTo } from "@utilities/styled-components";
import styled from "styled-components";
import CartSection from "./CartSection";
import SummarySection from "./SummarySection";
import AddItemToCart from "./AddItemToCart";
import { useState } from "react";

const ShoppingCartContainer = styled.div`
  display: flex;
  gap: 25px;
  margin-top: 5px;
  margin-left: -15px;
  margin-right: -15px;

  ${respondTo.xs`
    flex-direction:column;    
    
  `}
  ${respondTo.lg`
    flex-direction:row;
  `}
`;

function ShoppingCart() {
  const [showAddToCart, setShowAddToCart] = useState(false);
  return (
    <>
      <ScrollToTop />
      {/* <AddItemToCart status={showAddToCart} onClose={setShowAddToCart} /> */}
      <ShoppingCartContainer>
        {/* INFO 1st Section */}
        <CartSection />
        {/* INFO 2nd Section */}
        <SummarySection />
      </ShoppingCartContainer>
      {/* Promotional Section */}
      <YouMayLike
        page="ShoppingCart"
        showAddToCart={showAddToCart}
        onAddToCartActon={setShowAddToCart}
      />
    </>
  );
}

export default ShoppingCart;
